export enum IAvailableLocaleTypes {
  EN = 'en',
  TH = 'th',
  KH = 'kh',
  MM = 'mm',
  ZHHANS = 'zh-Hans',
  ZHHANT = 'zh-Hant',
}

export const DefaultLocale = IAvailableLocaleTypes.TH;
export const Locales = [
  IAvailableLocaleTypes.EN,
  IAvailableLocaleTypes.TH,
  IAvailableLocaleTypes.KH,
  IAvailableLocaleTypes.MM,
  IAvailableLocaleTypes.ZHHANS,
  IAvailableLocaleTypes.ZHHANT,
];

export const normalizeLocale = (locale?: string | null): IAvailableLocaleTypes => {
  const normalizedLocale = locale?.trim().replace(/_/g, '-').toLowerCase();

  if (normalizedLocale?.startsWith('en')) return IAvailableLocaleTypes.EN;
  if (normalizedLocale?.startsWith('th')) return IAvailableLocaleTypes.TH;
  if (normalizedLocale === 'kh' || normalizedLocale?.startsWith('km')) return IAvailableLocaleTypes.KH;
  if (normalizedLocale === 'mm' || normalizedLocale?.startsWith('my')) return IAvailableLocaleTypes.MM;
  if (
    normalizedLocale?.startsWith('zh-hant') ||
    ['zh-tw', 'zh-hk', 'zh-mo'].includes(normalizedLocale ?? '')
  ) {
    return IAvailableLocaleTypes.ZHHANT;
  }
  if (normalizedLocale?.startsWith('zh')) return IAvailableLocaleTypes.ZHHANS;

  return DefaultLocale;
};

export const toProductApiLanguage = (locale?: string | null): string => {
  const normalizedLocale = normalizeLocale(locale);

  if (normalizedLocale === IAvailableLocaleTypes.ZHHANS || normalizedLocale === IAvailableLocaleTypes.ZHHANT) {
    return 'zh_Hans';
  }
  return normalizedLocale;
};

export const toHtmlLanguage = (locale: IAvailableLocaleTypes): string => {
  if (locale === IAvailableLocaleTypes.KH) return 'km';
  if (locale === IAvailableLocaleTypes.MM) return 'my';

  return locale;
};
